import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=87ee3334&scoped=true&"
import script from "./Groups.vue?vue&type=script&lang=js&"
export * from "./Groups.vue?vue&type=script&lang=js&"
import style1 from "./Groups.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ee3334",
  null
  
)

export default component.exports